// Sugalarm — `prefers-reduced-motion` reader (cycle 214).
//
// Single-owner hook for the OS "reduce motion" accessibility signal. The
// app already honors reduced motion in CSS (`@media (prefers-reduced-motion:
// reduce)` blocks throughout), but the cycle-214 Pulse-Core status orb also
// needs the value in JS so it can collapse its animated `state` to the
// static "frozen" look. Mirrors the matchMedia subscribe shape of
// `useFrameVariant` so a settings-level toggle of the OS preference flips
// live without a reload.

import { useEffect, useState } from "react";

const QUERY = "(prefers-reduced-motion: reduce)";

function compute(): boolean {
  if (typeof window === "undefined" || !window.matchMedia) return false;
  return window.matchMedia(QUERY).matches;
}

export function usePrefersReducedMotion(): boolean {
  const [reduced, setReduced] = useState<boolean>(compute);

  useEffect(() => {
    if (typeof window === "undefined" || !window.matchMedia) return;
    const mq = window.matchMedia(QUERY);
    const onChange = () => setReduced(mq.matches);
    mq.addEventListener("change", onChange);
    return () => mq.removeEventListener("change", onChange);
  }, []);

  return reduced;
}
